import { FormattedMessage } from "react-intl";

const PreferencesMessageSuccess = () => {
  return (
    <span className="preferences__message">
      <FormattedMessage id="preferences-update-success" />
    </span>
  );
};

export default PreferencesMessageSuccess;
